/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
/** Common Components */
import Buttons from "../../../../../../components/ui/button/Buttons";
import FormCreator from "../../../../../../components/finalForms/FormCreator";
/** Common Services & Data Files */
import { AppIcons } from "../../../../../../data/appIcons";
import ToastService from "../../../../../../services/toastService/ToastService";
import projectmoduelFormData from "../config/ProjectModuel.data";
/** RTK Query */
import {
    useAddProjectModuelMutation,
    useLazyGetProjectModuelByIdQuery,
    useUpdateProjectModuelMutation
} from "../../../../../../app/services/projectModuleAPI";

const AddProjectModule = (props) => {
    const ref = useRef();
    /* State*/
    const [formData, setFormData] = useState(projectmoduelFormData);
    const ProjectId = props.ProjectId;
    // API'S Call
    const [addProjectModuel, {
        isSuccess: isProjectModuelAdded,
        isLoading: isProjectModuelAdding,
        data: addProjectModuelData
    },] = useAddProjectModuelMutation();

    const [updateProjectModuel, {
        isLoading: updateProjectModuelLoading,
        isSuccess: isSuccessUpdateProjectModuel,
        data: updateProjectModuelData
    }] = useUpdateProjectModuelMutation();

    const [getProjectModuelById, {
        isFetching: isProjectModuelfetching,
        isSuccess: isProjectModuelsuccess,
        data: ProjectModuelData
    },] = useLazyGetProjectModuelByIdQuery();
    
    //** useEffect's */
    useEffect(() => {
        formReset();
        if (props.selectedId) {
            getProjectModuelById(props.selectedId);
        }
    }, [props.selectedId, getProjectModuelById]);

    useEffect(() => {
        if (isProjectModuelsuccess && !isProjectModuelfetching && ProjectModuelData) {
            if (ProjectModuelData) {
                let Data = { ...formData };
                const { projectModule } = ProjectModuelData;
                Data.initialState = {
                    projectModule
                };
                setFormData(Data);
            }
        };
    }, [isProjectModuelsuccess, isProjectModuelfetching, ProjectModuelData]);

    useEffect(() => {
        if (isSuccessUpdateProjectModuel && updateProjectModuelData) {
            if (updateProjectModuelData.errorMessage.includes("exists")) {
                ToastService.warning(updateProjectModuelData.errorMessage);
                return;
            } else {
                ToastService.success(updateProjectModuelData.errorMessage);
                backToList();
            }
        }
    }, [isSuccessUpdateProjectModuel, updateProjectModuelData])


    useEffect(() => {
        if (isProjectModuelAdded && addProjectModuelData) {
            if (addProjectModuelData.errorMessage.includes("exists")) {
                ToastService.warning(addProjectModuelData.errorMessage);
                return;
            }
            else {
                ToastService.success(addProjectModuelData.errorMessage);
                backToList();
            }
        }
    }, [isProjectModuelAdded, addProjectModuelData]);

    //** Funcation's */
    const handleProjectModuel = () => {
        const formData = ref.current.getFormData();
        if (!props.selectedId && formData) {
            if (formData) {
                const requestData = {
                    ...formData,
                    projectModule: formData.projectModule,
                    componentId: props.componentId,
                    projectId: ProjectId
                }
                addProjectModuel(requestData);
            }
        }
        else if (props.selectedId && formData) {
            const DataUpdate = {
                ...formData,
                projectModule: formData.projectModule,
                componentId: props.componentId,
                projectModuleId: props.selectedId,
                projectId: ProjectId
            }
            updateProjectModuel(DataUpdate)

        }
    }

    const formReset = () => {
        const projectForm = { ...projectmoduelFormData };
        projectForm.initialState = { ...projectmoduelFormData.initialState };
        setFormData(projectForm);
    }

    const backToList = () => {
        props.onSidebarClose();
        formReset();
    };


    return (
        <div className="">
            <form>
                <div className="row">
                    <FormCreator
                        config={formData}
                        ref={ref}
                        {...formData}
                    />

                </div>
            </form>
            <div className="row">
                <div className="col-12">
                    <div className="form-btn d-flex justify-content-end">

                        <Buttons
                            buttonTypeClassName="dark-btn"
                            onClick={backToList}
                            buttonText="Cancel"
                        />
                        <Buttons
                            buttonTypeClassName="theme-btn ml-4"
                            onClick={handleProjectModuel}
                            buttonText={props.selectedId ? "Update" : "Add"}
                            imagePath={AppIcons.AddIcon}
                            isLoading={isProjectModuelAdding || updateProjectModuelLoading}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

AddProjectModule.propTypes = {
    selectedId: PropTypes.number,
    componentId: PropTypes.number,
    onSidebarClose: PropTypes.func.isRequired
};

export default AddProjectModule;